import {$api} from "./index";

export const createChatAndMsg = async (firstSocketId, secondSocketId, message) => {
    const {data} = await $api.post('api/chat', {firstSocketId, secondSocketId, message})
    return data
}

export const createMsg = async (firstSocketId, secondSocketId, message, chatId) => {
    const {data} = await $api.post('api/chat/msg', {firstSocketId, secondSocketId, message, chatId})
    return data
}

export const fetchChat = async () => {
    const {data} = await $api.get('api/chat')
    return data
}

export const fetchMsg = async () => {
    const {data} = await $api.get('api/chat/msg')
    return data
}

